module.exports = __webpack_public_path__ + "img/80.bae6352.png";